import React from 'react';
import clsx from "clsx";
import PropTypes from 'prop-types';
import styles from './Button.module.scss';

export const Button = props => {
  const themeStyle = {
    outline: 'outlineTheme'
  };

  const {className, label, theme, disabled, ...other} = props;
  const type = themeStyle[theme]

  return (
    <button
      type="button"
      disabled={disabled}
      className={clsx(styles.container, {[styles[type]]: type, [styles.disabled]: disabled}, className)}
      {...other}>
      {label}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

export default React.memo(Button);
